/* */
import { cloneDeep } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState, useCallback } from 'react';
import actions from 'redux/actions';
import ResponderServices from 'services/ResponderServices';

const { getListDialog } = actions;

export default (filters, ...dependencies) => {
  const authReducer = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  return useEffect(() => {
    const { sessionId, isLogin } = authReducer;
    if (isLogin && sessionId) {
      //! Parse body
      const nextFilters = cloneDeep(filters || {});
      nextFilters.status = filters?.status?.value;
      nextFilters.contactGroupName = filters?.contactGroupName?.label;

      dispatch(getListDialog({ filters: nextFilters }));
    }
  }, [authReducer.isLogin, ...dependencies]);
};

//! DEPRECATED!!!
export const useGetListDialog = (filters) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetch = useCallback(() => {
    return new Promise(async (resolve, reject) => {
      try {
        const nextFilters = cloneDeep(filters || {});
        nextFilters.status = filters?.status?.value;
        nextFilters.contactGroupName = filters?.contactGroupName?.label;

        const response = await ResponderServices.getListDialogs({
          published: true,
          filters: nextFilters,
        });
        setData(response?.data);
        resolve();
      } catch (error) {
        setError(error);
        reject(error);
      }
    });
  }, []);

  const refetch = useCallback(async () => {
    await fetch();
  }, [fetch]);

  const refetchWithLoading = useCallback(async () => {
    try {
      setLoading(true);
      await fetch();
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }, [fetch]);

  useEffect(() => {
    refetchWithLoading();
  }, [refetchWithLoading]);

  return { data, loading, error, refetch, refetchWithLoading };
};
